import { Card, IconButton, Stack, useMediaQuery, useTheme } from '@mui/material';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import BaseDialog from '../../../ui/BaseDialog';
import DrawerBottom from '../../../ui/DrawerBottom';
import DynamicSvgIcon from '../../../ui/icons/DynamicSvgIcon';
import {
  WheelPicker,
  WheelPickerWrapper
} from "../components/WheelpPicker";
import { CheckIcon } from '../../../ui/icons';
import { useState } from 'react';

interface CategoryGroupSelectorProps {
  categoryGroups: any[];
  currentValue?: string;
  open: boolean;
  onClose: () => void;
  onSelect: (category: any) => void;
}

const CategoryGroupSelector = (props: CategoryGroupSelectorProps) => {
  const {categoryGroups, open, onClose, onSelect} = props,
    theme = useTheme(),
    { t } = useTranslation(['categorySelector']),
    isDesktop = useMediaQuery(theme.breakpoints.up('md'));

  const [value, setValue] = useState<string>();
  
  const handleOnSelect = () => {
    const category = categoryGroups.find(cg => cg.id === value);
    onSelect(category);
    onClose();
  };

  const renderCategoryGroups = (): any => {
    return (categoryGroups || []).map((catGroup: any) => ({
      value: catGroup.id,
      label: (
        <Stack key={catGroup.id || Date().toString()} direction="row" alignItems="center" spacing={2}>
          <Card elevation={4} sx={{ borderRadius: '50%', boxShadow: 'unset' }}>
            <DynamicSvgIcon svgUrl={catGroup.icon} color={catGroup.iconColor} size={30} iconSize={20} />
          </Card>
          <Typography component="span" variant="h2">{catGroup.name}</Typography>
        </Stack>
      )
    }));
  };

  const title = t('select_category_group', { ns: 'categorySelector', defaultValue: 'Chọn nhóm chi' });

  const content = (
    <WheelPickerWrapper>
      <WheelPicker
        classNames={{optionItem: 'wheel-picker-item', highlightItem: 'wheel-picker-highlight-item'}}
        options={renderCategoryGroups()}
        optionItemHeight={45}
        value={props.currentValue}
        onValueChange={setValue}
      />
    </WheelPickerWrapper>
  )

  // Render based on device type
  if (isDesktop) {
    return (
      <BaseDialog
        open={open}
        maxWidth='sm'
        onClose={onClose}
        title={title}
      >
        {content}
      </BaseDialog>
    );
  }

  return (
    <DrawerBottom
      open={open}
      onClose={onClose}
      title={title}
      zIndex={10000}
      extraAction={(
        <IconButton
          onClick={handleOnSelect}
          aria-label="Select category group"
        >
          <CheckIcon />
        </IconButton>
      )}
    >
      {content}
    </DrawerBottom>
  );
};

export default CategoryGroupSelector; 